<template>
  <div class="wrapper" :style="{ display: visible ? '' : 'none' }">
    <div class="container">
      <div class="md-layout">
        <div class="md-layout-item md-size-100">
          <h4 class="form-question">
            {{ langtext(quest.question) }}
            <span style="color: red">
              {{ quest.required === 1 ? "*" : "" }}
            </span>
          </h4>
        </div>
        <div class="md-layout-item md-size-100" style="padding-left: 20px">
          <answer-emoji
            @changed="changed"
            :ref="quest.id"
            :required="quest.required === 1"
            v-if="quest.answertype === 1"
          />
          <answer-yes-no
            @changed="changed"
            :ref="quest.id"
            :required="quest.required === 1"
            v-if="quest.answertype === 2"
          />
          <answer-yes-no
            @changed="changed"
            :ref="quest.id"
            :required="quest.required === 1"
            :commentrequired="quest.commentrequired === 1"
            :commenttitle="quest.commenttitle"
            :withcomment="true"
            v-if="quest.answertype === 3"
          />
          <answer-user-input
            :ref="quest.id"
            :required="quest.required === 1"
            v-if="quest.answertype === 7"
          />
          <answer-select
            @changed="changed"
            :ref="quest.id"
            :required="quest.required === 1"
            :controltype="'singleselect'"
            :id="quest.id"
            :linkid="linkid"
            v-if="quest.answertype === 5"
          />
          <answer-select
            @changed="changed"
            :ref="quest.id"
            :required="quest.required === 1"
            :controltype="'multiselect'"
            :id="quest.id"
            :linkid="linkid"
            v-if="quest.answertype === 6"
          />
          <answer-select
            @changed="changed"
            :ref="quest.id"
            :required="quest.required === 1"
            :controltype="'dropdown'"
            :id="quest.id"
            :linkid="linkid"
            v-if="quest.answertype === 8"
          />
          <answer-star
            @changed="changed"
            :ref="quest.id"
            :required="quest.required === 1"
            v-if="quest.answertype === 4"
          />
          <answer-nps
            @changed="changed"
            :ref="quest.id"
            :required="quest.required === 1"
            v-if="quest.answertype === 9"
          />
          <div style="padding-top: 10px; padding-bottom: 10px">
            <hr class="hr" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AnswerEmoji from "./AnswerEmoji";
import AnswerYesNo from "./AnswerYesNo";
import AnswerUserInput from "./AnswerUserInput";
import AnswerSelect from "./AnswerSelect";
import AnswerStar from "./AnswerStar";
import AnswerNps from "./AnswerNps";
export default {
  name: "question-item",
  components: {
    AnswerStar,
    AnswerEmoji,
    AnswerYesNo,
    AnswerUserInput,
    AnswerSelect,
    AnswerNps,
  },
  props: {
    question: Object,
    answers: String,
    activeonly: Number,
    linkid: String,
    controlstyle: Object,
  },
  data() {
    return {
      visible: true,
      quest: this.question,
      formstyle: this.controlstyle,
    };
  },
  methods: {
    value() {
      return this.$refs[this.quest.id].value();
    },
    validate() {
      return this.$refs[this.quest.id].validate();
    },
    isNegative() {
      return this.quest.negative && this.quest.active && this.visible
        ? this.$refs[this.quest.id].isNegative()
        : false;
    },
    changed(value) {
      this.$emit("changed", this.value());
    },
    applystyle() {
      if (this.formstyle) {
        let root = document.documentElement;
        if (this.formstyle.dividercolor) {
          root.style.setProperty(
            "--divider-color",
            this.formstyle.dividercolor
          );
        }
        if (this.formstyle.dividersize)
          root.style.setProperty("--divider-size", this.formstyle.dividersize);
      }
    },
  },
  mounted() {
    this.applystyle();
  },

  watch: {
    question() {
      this.quest = this.question;
    },
    controlstyle() {
      this.formstyle = this.controlstyle;
      this.applystyle();
    },
  },
};
</script>

<style>
:root {
  --divider-color: black;
  --divider-size: "10px";
}
.hr {
  border-top: var(--divider-size) solid var(--divider-color);
}
.form-question {
  color: var(--question-color);
  font-size: var(--question-size);
  font-weight: var(--question-bold);
}
</style>